import countriesJson from 'src/utils/countries.json';

/**
 * Country code for a region/country NAME as it appears in the visibility KPI data.
 * Real ISO countries resolve to their 2-letter code (France → "fr"); aggregate regions
 * absent from the ISO list (e.g. "EMEA") keep their full name, so the country bar shows
 * "EMEA" instead of a bogus 2-char slice ("EM"). Shared by useCountryData and
 * VisibilityProvider (previously duplicated `name.slice(0, 2)` in both).
 */
export const deriveCountryCode = (name: string): string => {
  const found = (countriesJson as Array<{ name: string; code: string }>).find(
    (c) => c.name === name
  );
  return found ? found.code : name;
};
